<style>
  .all-danphe-msgbox {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 350px;
  z-index: 9999;
}

.danphe-msgbox {
  display: flex;
  align-items: flex-start;
  background-color: #fff;
  border-left: 5px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 15px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.msg-icon i {
  font-size: 24px;
  margin-right: 12px;
  margin-top: 5px;
}

.msg-text {
  flex: 1;
}

.msg-status {
  font-weight: 600;
  margin: 0;
  font-size: 16px;
  color: #333;
}

.main-message {
  font-size: 14px;
  margin: 4px 0;
  color: #555;
}

.msg-box-close {
  margin-left: 8px;
  cursor: pointer;
  font-size: 18px;
  color: #aaa;
}
.msg-box-close:hover {
  color: #333;
}

/* Status colors */
.msg-success { color: #28a745; }
.msg-error   { color: #dc3545; }
.msg-warning { color: #ffc107; }
.msg-info    { color: #17a2b8; }
.msg-default { color: #6c757d; }

.msgbox-success { border-left-color: #28a745; }
.msgbox-error, .msgbox-failed { border-left-color: #dc3545; }
.msgbox-warning { border-left-color: #ffc107; }
.msgbox-info, .msgbox-notice { border-left-color: #17a2b8; }

</style>
   <div class="all-danphe-msgbox" *ngIf="this.msgBoxService.globalMsgbox && this.msgBoxService.globalMsgbox.length > 0">
    <ng-container *ngFor="let msg of this.msgBoxService.globalMsgbox; let i=index;">
      <div class="danphe-msgbox" [ngClass]="'msgbox-'+ msg.statusCode" *ngIf="msg.show">
        <div class="msg-icon">
          <div class="padding-8-all">
            <i *ngIf="msg.statusCode=='success'" class="fa fa-check msg-success"></i>
            <i *ngIf="msg.statusCode=='error' || msg.statusCode=='failed'" class="fa fa-close msg-error"></i>
            <i *ngIf="msg.statusCode=='notice'" class="fa fa-info-circle msg-info"></i>
            <i *ngIf="msg.statusCode=='warning'" class="fa fa-warning msg-warning"></i>
            <i *ngIf="msg.statusCode != 'notice'
         && msg.statusCode != 'failed'
         && msg.statusCode != 'error'
         && msg.statusCode != 'success'
         && msg.statusCode != 'warning'" class="fa fa-paper-plane msg-default"></i>

          </div>
        </div>
        <div class="msg-text padding-8-all">
          <p class="msg-status">
            {{msg.status}}
          </p>
          <ng-container *ngFor='let singlemsg of msg.message;let i=index;'>
            <p class="main-message" [innerHTML]="singlemsg"></p>
          </ng-container>
        </div>

        <div class="msg-box-close">
          <a class="close-btn" (click)="Close(i)"><i class="fa fa-times-circle"></i></a>
        </div>


      </div>
    </ng-container>
  </div>

   


